import React from 'react';
import injectSheet from 'react-jss';
import cn from 'classnames';
import PropTypes from 'prop-types';
import theme, { expandAbsolutely } from '../../styles/theme';

const Overlay = ({
  classes, className, show, onCloseClick,
}) => (
  <div className={cn(classes.overlay, { show }, className)}>
    <div className={classes.closeButton} onClick={onCloseClick} role="button" tabIndex="0" onKeyPress={onCloseClick} />
  </div>
);

Overlay.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  show: PropTypes.bool,
  onCloseClick: PropTypes.func.isRequired,
};

Overlay.defaultProps = {
  className: undefined,
  show: false,
};

export default injectSheet({
  overlay: {
    ...expandAbsolutely,
    backgroundColor: theme.colors.blackOpacity70,
    opacity: 0,
    transition: 'opacity 0.25s ease-in-out',
    '&.show': {
      opacity: 1,
    },
    [theme.breakpoints.up('md')]: {
      '&.show': {
        opacity: 0,
      },
    },
  },
  closeButton: {
    cursor: 'pointer',
    position: 'absolute',
    top: 16,
    right: 16,
    width: 32,
    height: 32,
    zIndex: 1,
    opacity: 0.7,
    transition: 'opacity 0.15s ease-in-out',
    '&:hover': {
      opacity: 1,
    },
    '&:before, &:after': {
      position: 'absolute',
      content: '""',
      left: 15,
      width: 2,
      height: 32,
      backgroundColor: theme.colors.white,
    },
    '&:before': {
      transform: 'rotate(45deg)',
    },
    '&:after': {
      transform: 'rotate(-45deg)',
    },
  },
})(Overlay);
